import React from 'react';
import { motion } from 'framer-motion';
import img from '../../assets/home/pe1.png';

const Performances = () => {
  // Variantes pour l'animation de glissement fluide
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Délai entre le titre et le texte
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: [0.25, 1, 0.5, 1] } // Ease-out fluide
    },
  };

  return (
    <section className="w-full bg-[#F6FAFD] py-24 px-8 md:py-40 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-16 lg:gap-24">
          
          {/* Bloc Texte - Animation Staggered */}
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            className="w-full lg:w-1/2 flex flex-col"
          >
           
            <motion.h2 
  variants={itemVariants}
  className="text-[#0A1931] text-[32px] md:text-[40px] font-black leading-[1.1] tracking-tight mb-6 font-inter"
>
  Nos performances
</motion.h2>
            
            <motion.p 
  variants={itemVariants}
  className="text-[#1A3D63]/85 text-[15px] md:text-[16px] leading-relaxed max-w-[480px] font-inter font-medium"
>
  Nodixs est une entreprise spécialisée dans les solutions 
  informatiques, l’hébergement et la cybersécurité. Nous 
  proposons des services fiables et sécurisés adaptés aux besoins des 
  entreprises.
</motion.p>
          </motion.div>

          {/* Bloc Image - Glissement depuis la droite */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.25, 1, 0.5, 1], delay: 0.2 }}
            className="w-full lg:w-1/2"
          >
            <div className="relative">
              {/* Effet de halo moderne en arrière-plan */}
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#B3CFE5]/30 to-transparent rounded-[3rem] blur-3xl opacity-50" />
              
              <img 
                src={img} 
                alt="Performances Illustration"
                className="relative z-10 w-full h-auto rounded-[2rem] shadow-[0_20px_50px_rgba(10,25,49,0.1)] border border-white"
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Performances;